import { EventTypes } from 'redux-segment';
import canUseDOM from '../common/canUseDom';

// All segment events should fire the same action.
export const SEGMENT_EVENT = 'SEGMENT_EVENT';

/**
 * Segment action used to identify a page event
 *
 * This action should typically get called from the constructor. Any meta
 * data required to fire the action can be passed through from the connected
 * route container.
 *
 * @param {Object} payload an object to send the event payload request.
 */
export const navigatedToPage = (name, properties = {}) => dispatch => {
  if (canUseDOM) {
    dispatch({
      type: SEGMENT_EVENT,
      meta: {
        analytics: {
          eventType: EventTypes.page,
          eventPayload: { name, properties },
        },
      },
    });
  }
};

/**
 * A common action meant to be triggered when a CTA is clicked. This is probably
 * best triggered from the `onClick` component hook.
 *
 * @param {String} ctaLocation location relative to the page that the CTA is rendered
 * @param {String} pageName the name of the page containing the CTA
 */
export const clickedNextButton = properties => async dispatch => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Clicked Next Button',
          properties: { ...properties },
        },
      },
    },
  });
};

/**
 * A common action meant to be triggered when a the onboarding skip button is clicked
 * @param {Object} properties
 */
export const skippedOnboarding = properties => async dispatch => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Clicked Skip',
          properties: { ...properties },
        },
      },
    },
  });
};

/**
 * A common action meant to be triggered when a the onboarding upgrade button is clicked
 * @param {Object} properties
 */
export const clickedSubscribeCTA = properties => async dispatch => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Clicked Subscribe CTA',
          properties: {
            ctaLocation: 'onboarding - upgrade',
            ...properties,
          },
        },
      },
    },
  });
};

/**
 * A common action meant to be triggered when a the onboarding favorites page is completed
 * @param {Object} properties
 */
export const finishedOnboardingFavorites = properties => async dispatch => {
  await dispatch({
    type: SEGMENT_EVENT,
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Selected Favorites',
          properties: {
            platform: 'web',
            screenName: 'add-favorites',
            ...properties,
          },
        },
      },
    },
  });
};
